<script lang="ts">
    import type { ApiSchemas } from '$lib/api/shopwareApi';
    import { usePropertiesContext } from '$lib/context';
    import Calendar from '$lib/assets/icons/productDetails/calendar.svg';
    import Grapes from '$lib/assets/icons/productDetails/grapes.svg';
    import Percent from '$lib/assets/icons/productDetails/percent.svg';
    import Marker from '$lib/assets/icons/productDetails/marker.svg';
    import Bottles from '$lib/assets/icons/productDetails/bottles.svg';
    import Mountain from '$lib/assets/icons/productDetails/mountain.svg';
    import Glas from '$lib/assets/icons/productDetails/glas.svg';
    import Mouth from '$lib/assets/icons/productDetails/mouth.svg';
    import Droplet from '$lib/assets/icons/productDetails/droplet.svg';

    const properties = usePropertiesContext();

    export let product: ApiSchemas['Product'];
    export let optionGroups;
    export let type;
    export let taste;

    let location = product.properties.find(
        (property: { groupId: string }) => property.groupId === properties.location.id
    );

    $: details = [
        {
            icon: Calendar,
            label: optionGroups?.[properties.year.id].options.find(
                (option: any) => option.id === optionGroups?.[properties.year.id].selected
            ).name
        },
        {
            icon: Grapes,
            label: type?.name ?? type?.translated?.name
        },
        {
            icon: Percent,
            label: product.translated.customFields.custom_lewo_erp_alcohol
        },
        {
            icon: Marker,
            label: product.translated.customFields.custom_lewo_erp_region
        },
        {
            icon: Bottles,
            label: optionGroups?.[properties.size.id].options.find(
                (option: any) => option.id === optionGroups?.[properties.size.id].selected
            ).name
        },
        {
            icon: Mountain,
            label: location?.name ?? location?.translated?.name
        },
        {
            icon: Glas,
            label: product.translated.customFields.custom_lewo_erp_category
        },
        {
            icon: Mouth,
            label: taste?.name ?? taste?.translated?.name
        },
        {
            icon: Droplet,
            label: product.translated.customFields.custom_lewo_erp_color
        }
    ];
</script>

<div class="grid grid-cols-2 sm:grid-cols-3 gap-y-7 gap-x-6 pb-3 font-medium text-17px tracking-[0.03em] text-base-300">
    {#each details as detail}
        {#if detail.label && detail.label !== 'unbekannt' && detail.label !== 'unknown' && !detail.label.startsWith('[')}
            <div class="flex gap-3 items-center">
                <img class="shrink-0" src={detail.icon} alt="icon" />
                <span>{detail.label ?? ''}</span>
            </div>
        {/if}
    {/each}
</div>
